var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"right-box-status"},[_c('span',{style:({color:_vm.txtColor})},[_vm._v(_vm._s(_vm.title))]),(_vm.rightShow)?_c('span',[_c('img',{attrs:{"src":require("../../../assets/travelAgency/right.png"),"alt":""}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }